export default {
  nav: {
    main: 'Principal',
    ordersAndInvoices: 'Commandes et Factures',
    drafts: 'Brouillons',
    automation: 'Automatisation',
    workspace: 'Espace de travail',
    templates: 'Modeles',
    delivery: 'Livraison',
    settings: 'Parametres',
    shippingLabels: "Etiquettes d'expedition",
    subscriptions: 'Abonnements',
    support: 'Assistance',
    developer: 'Developpeur',
    writeReview: 'Ecrire un avis',
    supportTicket: "Ticket d'assistance",
    welcomeTour: 'Visite guidee',
    administratorConsole: "Console d'administration",
    logout: 'Deconnexion',
  },
  dashboard: {
    pageTitle: 'Commandes et Factures',
    pageDescription: 'Manage your orders and invoices',
    title: 'Commandes et Factures',
    selectedOrders: '{count} commandes selectionnees',
    completed: '% termine',
    processing: 'Traitement en cours, veuillez patienter...',
    bulkDownload: 'Telechargement groupe',
    upgradeBulkDownload: 'Mettez a niveau votre plan pour le telechargement groupe',
    showFilters: 'Afficher les filtres',
    hideFilters: 'Masquer les filtres',
    creatingInvoices: 'Creation des factures, veuillez patienter...',
    bulkCreateInvoices: 'Creation groupee de factures',
    cannotCreateAutopilot: 'Vous ne pouvez pas creer de factures manuellement lorsque le mode de facturation est en pilote automatique.',
    exportInvoices: 'Exporter les factures ou les commandes',
    capturePayments: 'Capturer les paiements manuellement',
    filterOrders: 'Filtrer les commandes',
    error: 'Un probleme est survenu...',
    close: 'Fermer',
    chooseDate: 'Choisir une date',
    chooseIssueDate: "Choisir une date d'emission pour les factures selectionnees",
    cancel: 'Annuler',
    createInvoices: 'Creer des factures',
    storno: 'Storno',
    bulkOrderCapture: 'Capture groupee de commandes',
  },
  search: {
    createdBetween: 'Cree entre',
    modifiedBetween: 'Modifie entre',
    orderNumber: 'Commande #',
    invoiceNumber: 'Facture #',
    refundNumber: 'Remboursement #',
    customer: 'Client',
    payment: 'Paiement',
    any: 'Tous',
    authorized: 'Autorisé',
    pending: 'En attente',
    paid: 'Payé',
    partiallyPaid: 'Partiellement payé',
    refunded: 'Remboursé',
    voided: 'Annulé',
    partiallyRefunded: 'Partiellement remboursé',
    unpaid: 'Impayé',
    fulfillment: 'Expedition',
    fulfilled: 'Expédié',
    partial: 'Partiel',
    unfulfilled: 'Non expédié',
    loading: 'Chargement des commandes...',
    search: 'Rechercher',
  },
  orderList: {
    noCustomer: 'Aucun client',
    downloadOrder: 'Telecharger la commande',
    deleteWarning: 'Important ! Cela supprimera toutes les factures et remboursements crees apres la date :',
    includingInvoice: 'y compris la facture selectionnee #',
    pressOk: 'Appuyez sur OK pour continuer ou Annuler pour abandonner.',
    cannotCreateAutopilot: 'Vous ne pouvez pas creer de factures manuellement lorsque le mode de facturation est en pilote automatique.',
    createInvoice: 'Creer une facture pour cette commande',
    create: 'Creer',
    addCreditNote: 'Ajouter un avoir',
    createStorno: 'Creer une facture storno',
    refund: 'Rembourser',
    downloadInvoice: 'Telecharger cette facture',
    download: 'Telecharger',
    default: 'Par defaut',
    downloadStorno: 'Telecharger ce storno/avoir',
    fulfillOrder: 'Expedier la commande',
    orderNum: 'Commande #',
    locPrefix: 'Prefixe loc.',
    invoiceNum: 'Facture #',
    refundNum: 'Remboursement #',
    customerCol: 'Client',
    orderCreatedDate: 'Date de creation de la commande',
    orderModifiedDate: 'Date de modification de la commande',
    delivered: 'Livre',
    paymentStatus: 'Statut du paiement',
    fulfillmentStatus: "Statut de l'expedition",
    totalOutstanding: 'Montant total restant du',
    originalPrice: 'Prix original',
    noOrders: "Votre boutique n'a aucune commande pour le statut selectionne.",
    cannotCreateNoOrders: "Vous ne pouvez pas creer de factures lorsqu'il n'y a aucune commande.",
    createOrdersFirst: 'Veuillez creer au moins une commande et reessayer.',
    createOrders: 'Creer des commandes',
    loadingOrders: 'Chargement...',
    paidManual: 'Payé - Manuel',
    paid: 'Payé',
    refunded: 'Remboursé',
    pending: 'En attente',
    partiallyPaid: 'Partiellement payé',
    partiallyRefunded: 'Partiellement remboursé',
    fulfilled: 'Expédié',
    unfulfilled: 'Non expédié',
    deliveryPending: 'En attente',
    deliverNow: 'Livrer maintenant',
    deliveryPartial: 'Partielle',
    notDelivered: 'Non livré',
    deliverAgain: 'Livrer à nouveau',
    deliveryDetails: 'Détails de livraison',
    deliveryFailed: 'Livraison échouée',
    sent: 'Envoyé',
    failed: 'Échoué',
    toLabel: 'À',
    folderLabel: 'Dossier',
    open: 'Ouvert',
    invoice: 'Facture',
    creditNote: 'Avoir',
    stornoLabel: 'Storno',
    unknown: 'Inconnu',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablette clients',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Revenir à cette date',
    add: 'Ajouter',
    close: 'Fermer',
  },
  downloadDialog: {
    downloadType: 'Telecharger {type}...',
    selectTemplate: 'Selectionnez un modele dans la galerie pour exporter des commandes, factures, factures storno ou avoirs.',
    getMoreTemplates: 'Obtenir plus de modeles',
    createNewTemplate: 'Creer un nouveau modele',
    allCreatedBetween: 'Tous les {type} crees entre',
    selectedType: '{type} selectionne(s)',
    and: 'et',
    status: 'Statut',
    any: 'Tous',
    open: 'Ouvert',
    closed: 'Ferme',
    cancelled: 'Annule',
    paymentStatus: 'Statut du paiement',
    fulfillmentStatus: 'Statut d\'expédition',
    fulfilled: 'Expédié',
    partial: 'Partiel',
    unfulfilled: 'Non expédié',
    authorized: 'Autorisé',
    pending: 'En attente',
    paid: 'Payé',
    partiallyPaid: 'Partiellement payé',
    refunded: 'Remboursé',
    voided: 'Annulé',
    partiallyRefunded: 'Partiellement remboursé',
    unpaid: 'Impayé',
    format: 'Format',
    forLocation: 'Pour emplacement',
    advancedOptions: 'Options avancées',
    exportHSCodes: 'Exporter les codes SH d\'inventaire (plus lent)',
    noteChrome: 'Note: Pour un téléchargement optimal, Chrome est recommandé et tout bloqueur de publicités doit être désactivé.',
    downloadIndividually: 'Télécharger individuellement',
    downloadGrouped: 'Télécharger groupé',
  },
  templates: {
    pageTitle: 'Modeles',
    pageDescription: 'Customize your invoice templates',
    title: 'Modeles',
    installTranslated: 'Installer un modele traduit',
    installTranslatedDesc: 'Choisissez une langue differente en cliquant sur ce bouton.',
    createNew: 'Creer un nouveau modele si necessaire',
    createNewDesc: 'Cliquez sur ce bouton pour creer un nouveau modele si besoin.',
    customize: 'Personnaliser les modeles',
    customizeDesc: 'Cliquez sur le modele par defaut pour le personnaliser. Vous pouvez changer le logo, les couleurs et, pour les utilisateurs avances, le code source.',
    defaultTemplate: 'Facture, Storno et Avoir (Par defaut)',
    logo: 'Logo',
    colorPalette: 'Palette de couleurs',
    getColorPalettes: 'Obtenir des palettes de couleurs',
    paperSize: 'Taille du papier',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientation',
    landscape: 'Paysage',
    portrait: 'Portrait',
    margin: 'Marge (cm)',
    unsavedChanges: 'Modifications non enregistrees',
    discard: 'Abandonner',
    save: 'Enregistrer',
  },
  labels: {
    pageTitle: 'Etiquettes d',
    pageDescription: 'Create and manage shipping labels',
    title: "Etiquettes d'expedition",
    glsRequiresPro: "Les etiquettes d'expedition GLS pour l'EEU necessitent le plan Professionnel.",
    upgradeDesc: "Passez au plan Professionnel pour creer et gerer les etiquettes d'expedition.",
    upgradePlan: 'Mettre a niveau votre plan',
    eeuGls: 'EEU GLS',
    enabled: 'Active',
    country: 'Pays',
    hungary: 'Hongrie',
    slovakia: 'Slovaquie',
    czech: 'Tcheque',
    romania: 'Roumanie',
    slovenia: 'Slovenie',
    croatia: 'Croatie',
    senderId: "ID de l'expediteur",
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    name: 'Nom',
    city: 'Ville',
    address: 'Adresse',
    zipCode: 'Code postal',
    contactPerson: 'Personne de contact',
    phone: 'Telephone',
    email: 'E-mail',
    glsServices: 'Services GLS',
    expressService: 'Service express',
    exchangeService: "Service d'echange",
    smsService: 'Service SMS',
    smsText: 'Texte SMS',
    preAdviceService: 'Service PreAdvice',
    unsavedChanges: 'Modifications non enregistrees',
    discard: 'Abandonner',
    save: 'Enregistrer',
  },
  billing: {
    pageTitle: 'Facturation',
    pageDescription: 'Manage your subscription and billing',
    title: 'Facturation',
    subscriptionFor: "Plan d'abonnement pour la boutique",
    currentlySubscribed: 'Vous etes actuellement abonne au plan',
    plan: 'plan',
    cancelSubscription: "Annuler l'abonnement",
    upgradePlan: 'Mettre a niveau votre plan',
    professional: 'Professionnel',
    proPriceMonthly: '$29.99 / mois',
    upgrade: 'Mettre a niveau',
    includesAllStarter: 'Inclut toutes les fonctionnalites Starter, plus :',
    proFeature1: 'Suite de conformite mondiale : Prefixes par emplacement et numerotation sequentielle personnalisee',
    proFeature2: 'Localisation intelligente : E-mails traduits automatiquement et pieces jointes PDF localisees',
    proFeature3: 'Cycle de vie complet des documents B2B : Proformas, devis B2B et avoirs',
    proFeature4: 'Synchronisation comptable B2B : Precision a 3 decimales et affichage multi-devises',
    proFeature5: 'Sauvegardes automatiques : Copie automatique des factures sur FTP securise ou Google Drive',
    proFeature6: 'Shopify Flow : Automatisez la generation, la livraison et le storno des factures via les declencheurs et actions Flow',
    proFeature7: "IA avancee : Utilisez l'IA embarquee pour des clauses de mise en page conditionnelles complexes",
    proFeature8: 'Exports UBL XML & ZUGFeRD / Factur-X (conformite e-facturation europeenne)',
    proFeature9: 'Codes EPC QR pour les paiements mobiles POS instantanes',
    proFeature10: "Etiquettes d'expedition GLS pour l'EEU",
    proFeature11: 'Conservation fiscale de conformite de 7 ans',
    currentlyUsing: 'Vous utilisez actuellement notre plan',
    free: 'gratuit',
    subscriptionPlan: "d'abonnement.",
    monthlyUsage: 'Utilisation mensuelle',
    monthlyGenerated: '{count} / 50 factures ce mois-ci',
    monthlyLimitReached: 'Limite mensuelle atteinte. Passez au plan Starter pour des factures illimitees.',
    freePlan: 'Plan Gratuit',
    freeToInstall: 'Gratuit a installer',
    freeFeature1: "Jusqu'a 50 factures/commandes par mois",
    freeFeature2: 'Acces a tous les 31+ modeles predefinis',
    freeFeature3: 'Copilote IA basique',
    freeFeature4: "Telechargement et impression PDF standard",
    freeFeature5: 'Suite de documents standard (Factures, Bordereaux, Recus)',
    freeFeature6: 'Conservation securisee des factures pendant 3 mois',
    starterPlan: 'Plan Starter',
    starterPrice: '$9.99 / mois',
    starterPricePerInvoice: '+ 3c par facture creee',
    subscribe: "S'abonner",
    starterFeature1: 'Factures et commandes illimitees',
    starterFeature2: 'Livraison automatique des PDF par e-mail',
    starterFeature3: "Acces complet a l'editeur hybride et au Copilote IA",
    starterFeature4: 'Integration Shopify POS et codes-barres',
    starterFeature5: "Shopify Flow : Declencheurs et actions pour l'automatisation des factures",
    starterFeature6: 'Exports UBL XML / PEPPOL & ZUGFeRD / Factur-X (conformite e-facturation)',
    starterFeature7: 'Conservation securisee des factures pendant 1 an',
    proTaxOverrides: 'Surcharges fiscales personnalisees : TVA / GST par produit et taux par SKU',
    unsavedChanges: 'Modifications non enregistrees',
    discard: 'Abandonner',
    save: 'Enregistrer',
  },
  autopilot: {
    pageTitle: 'Automatisation',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatisation',
    autoCreate: 'Creer automatiquement les factures',
    disabled: 'Desactive (Manuel)',
    whenCreated: 'Lorsque les commandes sont creees',
    whenFulfilled: 'Lorsque les commandes sont expediees',
    whenPaid: 'Lorsque les commandes sont payees',
    autoCreateDesc: 'Les factures seront creees a la date ou les commandes sont creees, expediees ou payees.',
    autoStorno: 'Storno automatique des factures',
    whenCancelled: 'Lorsque les commandes sont annulees ou remboursees',
    autoStornoDesc: 'Les factures storno seront creees a la date ou les commandes sont annulees ou les remboursements sont crees.',
    cannotAutoFree: 'La creation automatique de factures ne peut pas etre effectuee avec le plan gratuit.',
    upgradePlan: 'Mettre a niveau votre plan',
    unsavedChanges: 'Modifications non enregistrees',
    discard: 'Abandonner',
    save: 'Enregistrer',
  },
  delivery: {
    pageTitle: 'Livraison',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Livraison',
    settings: 'Parametres',
    useOrderNumbers: 'Utiliser les numeros de commande pour les fichiers',
    sendIfCountry: "Envoyer si le pays de l'adresse de facturation est",
    countryCodesHint: 'Listez tous les codes pays separes par un point-virgule.',
    sendForTags: "Envoyer pour les clients ayant l'un des tags listes",
    tagsHint: 'Listez tous les tags separes par un point-virgule.',
    emailDelivery: 'Livraison par e-mail',
    sendAsPdf: 'Envoyer les factures en pieces jointes PDF aux clients',
    autoSend: "Envoyer automatiquement lorsqu'une facture est creee",
    subject: 'Objet',
    body: 'Corps',
    xmlAttachments: 'Pieces jointes XML',
    attachUbl: 'Joindre le XML UBL/PEPPOL (E-Factura)',
    attachZugferd: 'Joindre le XML ZUGFeRD / Factur-X',
    sendTestEmail: 'Envoyer un e-mail de test',
    sending: 'Envoi en cours...',
    customSmtp: 'Serveur SMTP personnalise',
    customSmtpDesc: 'Utiliser votre propre serveur de messagerie au lieu de celui par defaut',
    enableSmtp: 'Activer le SMTP personnalise',
    smtpHost: 'Hote SMTP',
    port: 'Port',
    useSsl: 'Utiliser SSL/TLS',
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    fromEmail: "E-mail de l'expediteur",
    fromName: "Nom de l'expediteur",
    shopifyLiquid: 'Modele Shopify Liquid',
    pasteInto: 'Collez ceci dans votre',
    orderConfirmation: 'modele de confirmation de commande',
    toAddLink: 'pour ajouter un lien de telechargement.',
    downloadInvoice: 'Telecharger votre facture',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Envoyer des requetes a ClientsTablet lorsque des factures sont creees',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Envoyer les factures PDF comme documents douaniers a ShippyPro pour les pays hors UE',
    ftpBackup: 'Sauvegarde FTP/SFTP',
    ftpDesc: 'Copier automatiquement les factures sur votre serveur',
    enableFtp: 'Activer la sauvegarde FTP automatique',
    host: 'Hote',
    useSftp: 'Utiliser SFTP (securise)',
    destinationFolder: 'Dossier de destination',
    xmlFiles: 'Fichiers XML',
    includeUbl: 'Inclure le XML UBL/PEPPOL (E-Factura)',
    includeZugferd: 'Inclure le XML ZUGFeRD / Factur-X',
    testConnection: 'Tester la connexion',
    testing: 'Test en cours...',
    pro: 'PRO',
    upgradeFtp: 'Passez au plan Professionnel pour copier automatiquement les factures sur votre serveur FTP/SFTP.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Synchroniser automatiquement les factures sur votre Drive',
    connected: 'Connecte',
    disconnect: 'Deconnecter',
    notWorking: 'Ca ne fonctionne pas ? Allez dans',
    googlePermissions: 'Permissions Google',
    removeThenReconnect: 'supprimez Invoice Browse, puis reconnectez.',
    connectGoogleDrive: 'Connecter Google Drive',
    upgradeGoogleDrive: 'Passez au plan Professionnel pour synchroniser automatiquement les factures sur Google Drive.',
    unsavedChanges: 'Modifications non enregistrees',
    discard: 'Abandonner',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Enregistrer',
  },
  bookkeeping: {
    pageTitle: 'Parametres',
    pageDescription: 'Configure your invoice settings',
    title: 'Parametres',
    owner: 'Proprietaire',
    email: 'Email',
    phone: 'Telephone',
    keepDifferentNumbering: 'Conserver une numerotation de factures differente pour chaque emplacement de commande',
    keepDifferentNumberingDisabled: "Conserver une numerotation de factures differente pour chaque emplacement de commande n'est pas une option activee avec votre plan.",
    locationEmailDesc: "Cela vous permet d'envoyer des e-mails et des factures traduits en fonction de l'emplacement de la commande : emplacement d'inventaire, adresse de livraison ou de facturation",
    upgradePlan: 'Mettre a niveau votre plan',
    matchingCriteria: 'Criteres de correspondance',
    locationId: "ID de l'emplacement",
    shippingCountryCode: "Code pays de l'adresse de livraison",
    billingCountryCode: "Code pays de l'adresse de facturation",
    matchLocationDesc: "Faire correspondre un emplacement en fonction de l'ID d'emplacement de la commande, du code pays de l'adresse de livraison ou de facturation.",
    companyInfo: "Informations sur l'entreprise",
    name: 'Nom',
    website: 'Site web',
    registrationNumber: "Numero d'enregistrement",
    taxId: 'Numero de TVA',
    addressSection: 'Adresse',
    streetName: 'Nom de la rue',
    streetNumber: 'Numero de rue',
    zip: 'Code postal',
    city: 'Ville',
    region: 'Region',
    country: 'Pays',
    bankingInfo: 'Informations bancaires',
    bankName: 'Nom de la banque',
    swift: 'Swift',
    currency: 'Devise',
    iban: 'IBAN',
    invoicing: 'Facturation',
    decimalPlaces: 'Nombre de decimales',
    invoicesPrefix: 'Prefixe des factures',
    currentInvoiceNumber: 'Numero de facture actuel',
    creditNotesPrefix: 'Prefixe des avoirs',
    currentCreditNoteNumber: "Numero d'avoir actuel",
    lastInvoiceDate: 'Date de la derniere facture',
    noInvoicesYet: "Aucune facture n'a encore ete creee.",
    confirmReverting: 'Confirmer la restauration du systeme',
    allInvoicesAfter: 'Toutes les factures et leurs stornos emis apres',
    willBeRemoved: 'seront supprimes. Continuer avec la restauration du systeme ?',
    cancel: 'Annuler',
    revert: 'Restaurer',
    revertDesc: 'La restauration du systeme effacera toutes les factures creees apres la date selectionnee.',
    revertToDate: 'Restaurer a cette date',
    reverting: 'Restauration du systeme, veuillez patienter...',
    useOrderNumbering: 'Utiliser la numerotation des commandes',
    showVat: 'Afficher la TVA sur les factures',
    overrideTaxes: 'Remplacer les taxes',
    pricesIncludeTax: 'Les prix incluent la taxe',
    productsTaxRate: 'Taux de taxe des produits',
    shippingTaxRate: "Taux de taxe de l'expedition",
    skusSeparated: 'SKUs separes par un point-virgule',
    skusTaxRate: 'Taux de taxe des SKUs',
    useOrderDates: 'Utiliser les dates de creation des commandes pour les factures',
    convertCurrency: 'Convertir les prix dans la devise de paiement du client',
    unsavedChanges: 'Modifications non enregistrees',
    discard: 'Abandonner',
    save: 'Enregistrer',
  },
  drafts: {
    pageTitle: 'Brouillons',
    pageDescription: 'Manage your draft orders',
    title: 'Brouillons',
    download: 'Telecharger',
    newDraft: 'Nouveau brouillon',
    exporting: 'Exportation {status}%...',
    accessNotGranted: "L'acces aux brouillons de commandes n'a pas ete accorde. Veuillez",
    reLogin: 'vous reconnecter',
    toGrantPermissions: 'pour accorder les permissions requises "Brouillons de commandes".',
    pushFailed: "L'envoi vers Shopify a echoue :",
    exportError: "Erreur d'exportation :",
    confirmDelete: 'Etes-vous sur de vouloir supprimer ce brouillon ?',
    incompleteCustomer: 'Les donnees du client sont incompletes :',
    pushWithoutCustomer: 'Le brouillon sera envoye vers Shopify sans les donnees client. Continuer ?',
    customerNotInShopify: "Ce client n'existe pas encore dans Shopify.",
    warnings: 'Avertissements :',
    createCustomerAndPush: 'Creer le client dans Shopify et envoyer le brouillon de commande ?',
    downloadTitle: 'Télécharger les brouillons',
    cancel: 'Annuler',
  },
  draftEdit: {
    number: "Numéro",
    prefix: "Préfixe",

    newDraft: 'Nouveau brouillon',
    editDraft: 'Modifier le brouillon',
    viewInShopify: 'Voir dans Shopify',
    back: 'Retour',
    createDraft: 'Creer le brouillon',
    saveChanges: 'Enregistrer les modifications',
    documentType: 'Type de document',
    draftOrder: 'Brouillon de commande',
    quote: 'Devis',
    proforma: 'Proforma',
    manualInvoice: 'Facture manuelle',
    currency: 'Devise',
    expiryDate: "Date d'expiration",
    status: 'Statut',
    draft: 'Brouillon',
    sent: 'Envoye',
    accepted: 'Accepte',
    customer: 'Client',
    firstName: 'Prenom',
    lastName: 'Nom',
    email: 'E-mail',
    phone: 'Telephone',
    company: 'Entreprise',
    taxId: 'Numero de TVA',
    billingAddress: 'Adresse de facturation',
    address: 'Adresse',
    aptSuite: 'Apt/Suite',
    city: 'Ville',
    province: 'Province',
    countryField: 'Pays',
    zip: 'Code postal',
    shippingAddress: 'Adresse de livraison',
    sameAsBilling: 'Identique a la facturation',
    lineItems: 'Articles',
    shipping: 'Livraison',
    shippingTitle: 'Titre',
    shippingPlaceholder: 'ex. Livraison standard',
    price: 'Prix',
    note: 'Note',
    notePlaceholder: 'Note interne ou message au client...',
    summary: 'Resume',
    subtotal: 'Sous-total',
    discounts: 'Remises',
    tax: 'Taxe',
    total: 'Total',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Entrez l\'adresse de votre boutique',
    loginWith: 'Se connecter avec',
    createAccount: 'Creer un nouveau compte',
    placeholder: 'nom-de-votre-boutique',
    shopRequired: 'Le nom de la boutique est requis',
    login: 'Connexion',
    shopify: 'Shopify',
    terms: 'Conditions generales',
    privacy: 'Politique de confidentialite',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Vous appreciez Invoice Browse ?',
    description: "Vous avez cree vos premieres factures ! Si vous trouvez l'application utile, un avis rapide sur le Shopify App Store nous aide beaucoup.",
    reward: 'En remerciement, nous remettrons votre compteur mensuel a 0',
    leaveReview: 'Laisser un avis',
    maybeLater: 'Peut-etre plus tard',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Bienvenue sur Invoice Browse',
    welcomeContent: 'Laissez-moi vous montrer comment l\'utiliser.',
    dashboardTitle: 'Tableau de bord',
    dashboardContent: 'L\'ecran que vous voyez est le tableau de bord principal. Ici vous pouvez trouver toutes les commandes et les exporter vers differents types de documents comme : factures, bordereaux de livraison et autres.',
    automationTitle: 'Simplifiez-vous la vie',
    automationContent: 'Activez l\'automatisation pour creer des factures chaque fois que des commandes sont payees ou remboursees.',
    templatesTitle: 'Personnaliser les modeles',
    templatesContent: 'Entrez ici pour traduire votre modele, le personnaliser ou en creer un nouveau.',
    deliveryTitle: 'Livraison',
    deliveryContent: 'Configurez notre application pour copier automatiquement les documents crees vers FTP, Google Drive, ou en pieces jointes d\'e-mails.',
    settingsTitle: 'Parametres',
    settingsContent1: 'Ajustez le numero de telephone, l\'e-mail et d\'autres champs utilises sur les documents.',
    settingsContent2: 'Modifiez le numero de depart des documents ou effacez les documents crees apres une date.',
    settingsContent3: 'Remplacez les taux de TVA pour la livraison et les produits',
    settingsContent4: 'Modifiez le nombre de decimales',
    reviewTitle: 'Ecrire un avis',
    reviewContent: 'Soutenez notre equipe en nous laissant un bon avis !',
    tourTitle: 'Visite guidee',
    tourContent: 'Vous pouvez rouvrir cette visite guidee depuis ici.',
    createDocTitle: 'Creez votre premier document',
    createDocContent: 'Cliquez sur le bouton Creer pour creer votre premier document.',
    docNumberTitle: 'Numero de document',
    docNumberContent: 'Le premier document a le numero 1 attribue. Si vous souhaitez commencer avec un autre numero, vous pouvez le modifier dans les Parametres.',
    downloadDocTitle: 'Telecharger le document',
    downloadDocContent: 'Cliquez sur le menu deroulant Telecharger et selectionnez un modele de document pour exporter votre commande en PDF.',
  },
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    discard: 'Abandonner',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Creer',
    loading: 'Chargement...',
    unsavedChanges: 'Modifications non enregistrees',
    upgradePlan: 'Mettre a niveau votre plan',
  },
  languageSelector: {
    label: 'Langue',
    auto: 'Detection automatique',
  },
  draftList: {
    draftNum: 'Brouillon #',
    shopifyId: 'Shopify ID',
    type: 'Type',
    customer: 'Client',
    total: 'Total',
    status: 'Statut',
    delivered: 'Livré',
    date: 'Date',
    actions: 'Actions',
    noCustomer: 'Pas de client',
    noDrafts: 'Aucun brouillon ou devis trouvé.',
    loading: 'Chargement...',
    download: 'Télécharger',
    default: 'Par défaut',
    pending: 'En attente',
    deliverNow: 'Livrer maintenant',
    deliveryDetails: 'Détails de livraison',
    sent: 'Envoyé',
    failed: 'Échoué',
    deliverAgain: 'Livrer à nouveau',
    partial: 'Partiel',
    notDelivered: 'Non livré',
    deliveryFailed: 'Livraison échouée',
    unknown: 'Inconnu',
    edit: 'Modifier',
    send: 'Envoyer',
    pushToShopify: 'Envoyer à Shopify',
    complete: 'Terminer',
    duplicate: 'Dupliquer',
    delete: 'Supprimer',
    quote: 'Devis',
    proforma: 'Proforma',
    draftOrder: 'Commande brouillon',
    manualInvoice: 'Facture manuelle',
  },
  draftSearch: {
    createdBtw: 'Créé entre',
    draftNum: 'Brouillon #',
    shopifyId: 'Shopify ID',
    customer: 'Client',
    status: 'Statut',
    type: 'Type',
    delivery: 'Livraison',
    any: 'Tous',
    draft: 'Brouillon',
    sent: 'Envoyé',
    accepted: 'Accepté',
    expired: 'Expiré',
    converted: 'Converti',
    cancelled: 'Annulé',
    quote: 'Devis',
    proforma: 'Proforma',
    draftOrder: 'Commande brouillon',
    manualInvoice: 'Facture manuelle',
    delivered: 'Livré',
    notDelivered: 'Non livré',
    pending: 'En attente',
    search: 'Rechercher',
  },
  draftDownload: {
    title: 'Télécharger brouillons et devis...',
    selectTemplate: 'Sélectionnez un modèle dans la galerie pour exporter des brouillons, devis ou proformas.',
    allDraftsBetween: 'Tous les brouillons entre',
    selectedDrafts: 'Brouillons sélectionnés',
    and: 'et',
    status: 'Statut',
    documentType: 'Type de document',
    any: 'Tous',
    draft: 'Brouillon',
    sent: 'Envoyé',
    accepted: 'Accepté',
    expired: 'Expiré',
    converted: 'Converti',
    cancelled: 'Annulé',
    quote: 'Devis',
    proforma: 'Proforma',
    draftOrder: 'Commande brouillon',
    manualInvoice: 'Facture manuelle',
    format: 'Format',
    noTemplates: 'Aucun modèle trouvé',
    noTemplatesForType: 'Aucun modèle trouvé pour le type de document « {type} ».',
    installTemplates: 'Installer des modèles',
    toStartExporting: 'pour commencer à exporter.',
    noteChrome: 'Note : Pour un téléchargement optimal, Chrome est recommandé et tout bloqueur de publicités doit être désactivé.',
    cancel: 'Annuler',
    downloadIndividually: 'Télécharger individuellement',
    downloadGrouped: 'Télécharger groupé',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Installer un nouveau modèle',
    tabStyle: 'Style',
    tabContent: 'Contenu',
    tabTranslations: 'Traductions',
    tabSettings: 'Paramètres',
    tabCode: 'Code',
    tabCopilot: 'Copilote IA',
    logo: 'Logo',
    colorPalette: 'Palette de couleurs',
    colorText: 'Texte',
    colorBg: 'Arrière-plan',
    colorBorder: 'Bordure',
    colorPrimary: 'Primaire',
    colorAccent: 'Accent',
    font: 'Police',
    fontDefault: 'Par défaut (DM Sans)',
    fontSize: 'Taille de police',
    fontSizeDefault: 'Par défaut (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Petit',
    fontSizeMediumSmall: 'Moyen-petit',
    fontSizeMedium: 'Moyen',
    fontSizeMediumLarge: 'Moyen-grand',
    fontSizeLarge: 'Grand',
    fontSizeExtraLarge: 'Très grand',
    documentTitle: 'Titre du document',
    documentTitlePlaceholder: 'ex. Facture, Facture fiscale...',
    noToggleSupport: 'Ce modèle ne prend pas en charge les contrôles à bascule. Passez à un modèle de galerie pour une personnalisation complète.',
    sections: 'Sections',
    shippingAddress: 'Adresse de livraison',
    bankPaymentDetails: 'Informations bancaires/de paiement',
    paymentStatusBadge: 'Badge de statut de paiement',
    orderNotes: 'Notes de commande',
    trackingFulfillment: 'Suivi/expédition',
    termsConditions: 'Conditions générales',
    signatureLines: 'Lignes de signature',
    qrCode: 'Code QR',
    lineItems: 'Articles',
    taxColumns: 'Colonnes de taxe (TVA)',
    productSku: 'SKU du produit',
    productImages: 'Images du produit',
    discountBreakdown: 'Détail des remises',
    itemWeight: 'Poids de l\'article',
    hsCode: 'Code HS (douanes)',
    mergeDiscounts: 'Fusionner les remises dans le prix du produit',
    showOrderDiscountAsSummary: 'Afficher la remise de commande sur une ligne récapitulative',
    totals: 'Totaux',
    subtotalBeforeTax: 'Sous-total (hors taxe)',
    taxBreakdownByRate: 'Ventilation des taxes par taux',
    shippingCostSeparate: 'Frais de livraison en ligne séparée',
    dueDate: 'Date d\'échéance',
    formatting: 'Mise en forme',
    dateFormat: 'Format de date',
    decimalPlaces: 'Décimales',
    paymentTerms: 'Conditions de paiement',
    paymentTermsNone: 'Aucune',
    thankYouMessage: 'Message de remerciement',
    thankYouPlaceholder: 'Merci pour votre achat !',
    countryMatchTitle: 'Utiliser ce modèle lorsque l\'adresse de livraison ou de facturation correspond à ce pays',
    addressType: 'Type d\'adresse',
    addressDisabled: 'Désactivé',
    addressShipping: 'Adresse de livraison',
    addressBilling: 'Adresse de facturation',
    country: 'Pays',
    anyCountry: 'Tout pays',
    countryMatchDesc: 'Lorsqu\'il est activé, ce modèle sera utilisé automatiquement pour les commandes dont l\'adresse sélectionnée correspond au pays choisi.',
    languagePreset: 'Préréglage de langue',
    selectLanguage: 'Sélectionner une langue...',
    languagePresetDesc: 'La sélection d\'une langue remplit tous les libellés ci-dessous. Vous pouvez ensuite personnaliser les champs individuels.',
    paperSize: 'Taille du papier',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Paysage',
    margin: 'Marge (cm)',
    template: 'Modèle',
    templateName: 'Nom',
    systemAlias: 'Alias système',
    systemAliasDesc: 'pour les routes URL POS/Admin',
    systemAliasNone: 'Aucun',
    defaultTemplate: 'Modèle par défaut',
    defaultTemplateDesc: 'Utilisé pour les liens directs partagés avec les clients.',
    posRouteDesc: 'Correspond à /template/[alias]/receipt.pdf pour l\'intégration POS.',
    documentType: 'Type de document',
    invoiceCreditNote: 'Facture + Avoir',
    order: 'Commande',
    invoiceOnly: 'Facture uniquement',
    quoteEstimate: 'Devis/Estimation',
    proformaInvoice: 'Facture proforma',
    refund: 'Remboursement',
    stornoInvoice: 'Facture d\'annulation',
    creditNoteOnly: 'Avoir uniquement',
    reportLiquid: 'Rapport (Liquid uniquement)',
    hideRemovedItems: 'Masquer les articles supprimés/remboursés',
    location: 'Emplacement',
    locationEmpty: 'Laisser vide pour utiliser pour tous les emplacements',
    dangerZone: 'Zone de danger',
    dangerZoneDesc: 'Supprimer définitivement ce modèle de votre compte.',
    removeTemplate: 'Supprimer le modèle',
    bodyTemplate: 'Modèle principal',
    bodyTemplateDesc: 'Utilise la syntaxe Mustache ou Liquid. Cliquez sur un extrait :',
    rowTemplate: 'Modèle de ligne',
    rowTemplateDesc: 'Rendu une fois par article. Cliquez sur un extrait :',
    variableReference: 'Référence des variables',
    formatCode: 'Formater le code',
    insert: 'Insérer',
    copy: 'Copier',
    loadModelContinue: 'Charger le modèle et continuer',
    cancel: 'Annuler',
    copilotPlaceholder: 'Essayez : traduire en français, afficher les colonnes de taxe, ajouter un code-barres...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Annuler',
    redo: 'Rétablir',
    aiThinking: 'L\'IA réfléchit...',
    proposedChanges: 'Modifications proposées',
    applyChanges: 'Appliquer les modifications',
    dismiss: 'Ignorer',
    aiEngineReady: 'Moteur IA prêt',
    loadingAiModel: 'Chargement du modèle IA...',
    aiEngineOff: 'Moteur IA désactivé —',
    loadForAdvanced: 'charger pour édition avancée',
    instantCommands: 'traduire, afficher/masquer des sections, ajouter des extraits, changer police/couleurs/papier',
    aiEngineDesc: 'modifications HTML structurelles, changements de mise en page, modifications personnalisées',
    aiLocalDesc: 'Le modèle s\'exécute localement via WebGPU — aucune donnée ne quitte votre navigateur.',
    aiUpgradeDesc: 'passez à Starter ou Professional pour débloquer l\'édition IA avancée.',
    upgrade: 'Mettre à niveau',
    loadAiQuestion: 'Charger le moteur IA ?',
    loadAiDesc: 'Le modèle IA sur appareil sera téléchargé et exécuté localement via WebGPU. Cela nécessite ~1-3 Go de VRAM/RAM libre et un GPU moderne.',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/fr.js